<template>
  <sh-doc-card content-path="/terms-usage.html"/>
</template>

<script>
    import DocCard from "../../components/common/DocCard";
    export default {
        name : 'App',
        props : {
            content_path : String,
        },
        components : {
            "sh-doc-card" : DocCard
        }
    }
</script>

<style lang="sass">

</style>
